import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getFormFieldsCleaning, processCleaning } from "../helpers/cleanings";
import { FormFields } from "../../components/Form/Fields";
import { FormInputSubmit } from "../../components/Form/Input/Submit";
import { returnValues} from "../../components/Form/Formfunctions";
import { ContentWrapper } from "../../components/Content/Wrapper";
import { ValidateResponse } from "../helpers/global";

/**
 * #hierbenik#2052 verwerken checkbox-defined ... en dan ... testentestentesten
 * Alle cleaning-formulieren testen!
 * -@todo: naar keuring ..
 */

export function AppCleaningsProcess({
    setGlobalMessage,
    cleaningId,
    returnPath
}) {

    const navigate = useNavigate();
    const [formFields, setFormFields] = useState();
    const [defaultFormFields, setDefaultFormFields] = useState();
    const [values, setValues] = useState({});
    const [errors, setErrors] = useState();
    const [submit, setSubmit] = useState(false);

    const [showWarehouse, setShowWarehouse] = useState(false);

    useEffect(() => {
        getFormFields();
    }, []);


    const getFormFields = () => {

        const formData = cleaningId;
        getFormFieldsCleaning(formData).then((res) => {
            const response = ValidateResponse(res.data, 'form');

            if (response.status === 'error') {
                setGlobalMessage(response.message, response.status);
            }
            else {
                setDefaultFormFields(response.form);
                setFormFields(response.form.INITIAL);
                setValues({ cleaningId: cleaningId, formType: response.form.type });

            }

        }).catch((error) => {
            const response = ValidateResponse(error, 'cleaning');
            setGlobalMessage(response.message, response.status);
        })
    }

    const submitForm = () => {

        Object.keys(formFields).forEach(field => {
            if (values[field] === undefined) {
                values[field] = '';
            }
        })

        let formData = {
            'cleaningId': cleaningId,
            'data': values,
        }

        // ALLE velden worden aan de backend gevalideerd!

        processCleaning(formData).then((res) => {

            const response = ValidateResponse(res.data, 'cleaningResult');

            if (response.status === 'error') {
                setErrors(response.invalidFields);
                setGlobalMessage(response.message ?? 'Er is iets foutgegaan', response.status);
                return;
            }
            else if (response.cleaningResult.status === 'INSPECTION' && response.cleaningResult.productId > 0) {
                navigate('/products/intern/inspections/' + response.cleaningResult.productId, {
                    replace: true,
                    state: { 'message': response.message, 'type': response.status, 'currentPage': 1 }
                });
            }
            else {
                navigate(returnPath + '/overview', {
                    replace: true,
                    state: { 'message': response.message, 'type': response.status, 'currentPage': 1 }
                });
            }

        }).catch((error) => {
            const response = ValidateResponse(error);
            setGlobalMessage(response.message, response.status);
        })
    }

    const setInputValues = (key, value, identifier = null) => {

        switch (key) {
            case 'status':
                if (value === 'INSPECT') {
                    setFormFields(defaultFormFields.INITIAL);
                } else {
                    let allFields = defaultFormFields.ALL;
                    delete (allFields.warehouseId);
                    setFormFields(allFields);
                }
                break;

            case 'changeWarehouse':
                if (value === 'DIRECT' || value === 'TRANSPORT') {
                    setShowWarehouse(true);
                }
                else {
                    setShowWarehouse(false);
                }
                break

        }
        setValues(returnValues(values, key, value, identifier));
        if(submit === false) {
            setSubmit(true);
        }
    }

    const setInputErrors = (key, value, identifier = null) => {

        // Validate gaat via de backoffice
    }

    const cleaningForm = () => {

        return (
            <>
                <FormFields
                    formFields={formFields}
                    setValues={setInputValues}
                    setErrors={setInputErrors}
                    formValues={values}
                    formErrors={errors}
                    wrapper="wrapper"
                />

                {showWarehouse === true &&
                    <FormFields
                        formFields={defaultFormFields.WAREHOUSE}
                        setValues={setInputValues}
                        setErrors={setInputErrors}
                        formValues={values}
                        formErrors={errors}
                        wrapper="wrapper"
                    />
                }

                {(values.status !== undefined || submit === true) &&
                    <div>
                        <div className="spacer" />
                        <FormInputSubmit handleSubmit={submitForm} submitLabel="Verwerken" />
                    </div>
                }
            </>
        )
    }

    if (formFields !== undefined) {
        return (
            <div>
                <ContentWrapper type='outline-box' content={cleaningForm()} />
            </div>
        );
    }
    else {
        return <></>
    }
}